import Controller from '../abstracts/Controller';

export default class EditorialpageController extends Controller {
  static get COMPONENTS() {
    return ['ProductScrollComponent', 'TwinWidgetCarouselComponent'];
  }
}
